import React, { useState, useEffect, useRef, useCallback, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useHistory, Link } from 'react-router-dom';
// import ReactHtmlParser from 'react-html-parser';
import { isEqual, isEmpty } from 'lodash';

import RenewalOrderDetailCard from '../../../common/renewalOrderDetailCard/RenewalOrderDetailCard';
import RenewalPersonalInfoCard from '../../../common/renewalPersonalInfoCard/RenewalPersonalInfoCard';
import { policyFetch, customerFetch, validateCart, calculateCart, customerFindByNumber, customerFetchByNumber } from '../../../actions';
import { UpgradeCondition } from '../../condition/PaymentCondition';
import { Card, Modal } from '../../../helpers';
import { commonConstant, CustomCheckbox, StickyBottom } from '../../../common';
import { activityService } from '../../../services';

import './ConfirmPayment.scss';
import AmwayRedirect from '../../redirect/Redirect';
import { excludeProductEntries } from '../../../helpers/Products/excludeProductEntries';
import { LABEL_ACCEPT_TNC_MEMBER_UPGRADE } from '../../../common/commonConstant';
import LoadingOverlay from 'react-loading-overlay';
import { PlaceOrders } from '../../../services/promotion/payment.service';
import { liffGetProfile } from '../../../services/promotion/auth.service';
import { handlePriceFormatting } from '../../../utill.func';

const liff = window.liff;

const banksImagePath = {
  BBL: '/images/banks/bank-bbl.svg',
  KBANK: '/images/banks/bank-kbank.svg',
  KTB: '/images/banks/bank-ktb.svg',
  TMB: '/images/banks/bank-tmb.svg',
  SCB: '/images/banks/bank-scb.svg',
  BAY: '/images/banks/bank-bay.svg',
  TBANK: '/images/banks/bank-tbank.svg',
  UOB: '/images/banks/bank-uob.svg',
};

export const ConfirmPayment = () => {
  const cartRef = useRef();
  const checkboxRef = useRef(null);
  const [showConsent, setShowConsent] = useState(false);
  const [isCalculated, setCalculated] = useState(false);
  const [accept, setAccept] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [redirect, setRedirect] = useState();
  const [modalContent, setModalContent] = useState();
  const [formattedDate, setFormattedDate] = useState("")
  const [cartData, setCartData] = useState(null)
  const [findData, setFindData] = useState(null)
  const { customer, cart, pickStore, find } = useSelector(state => state);
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const sendAvtivity = useCallback((status) => {
    activityService.create({
      uid: customer.uid,
      userId: customer._id,
      status: status,
      action: 'CONFIRM_PAYMENT_FOR_MAGAZINE',
    });
  });

  useEffect(() => {
    if (isEmpty(cart) || isEmpty(customer) || isEmpty(find)) {
      console.log('useEffect error')
      return handleToggleModal('ERROR');
    }
    dispatch(customerFetch(customer.amwayNumber));
    dispatch(customerFetchByNumber(customer.amwayNumber));
    dispatch(validateCart(customer.amwayNumber, customer.partyId, cart.data.code));
    cartRef.current = cart;

  }, []);

  useEffect(() => {
    try {
      if (cart.code === 500) {
        handleToggleModal('ERROR');
      } else if (cart.validate && !isEqual(cart.validate, cartRef.current.validate) && cart.validate.code === 200) {
        dispatch(calculateCart(customer.amwayNumber, customer.partyId, cart.data.code));
      } else if (cart.calculated && ((cart.calculated !== cartRef.current.calculated) || cartRef?.current?.calculated)) {
        setCalculated(true);
      } else if (cart.validate && cart.validate.code !== 200) {
        handleToggleModal('ERROR');
      }
      if (cart?.data) {
        setCartData(cart.data);
        if (cart?.data?.account?.expiryDate) {
          const date = new Date(cart.data.account.expiryDate);
          const newDate = `${date.getDate()} ${commonConstant.MONTHS.th[date.getMonth()]} ${date.getFullYear() + 543}`;
          setFormattedDate(newDate)
        }
      }
      cartRef.current = cart;
    } catch (e) { }
  }, [cart]);

  useEffect(() => {
    if (showConsent) {
      dispatch(policyFetch({}));
    }
  }, [showConsent]);

  useEffect(() => {
    if (!isEmpty(find)) {
      setFindData(find)
    }
  }, [find]);

  useEffect(() => {
    if (findData && findData.partyList) {
      if (findData.partyList[0].phoneList.length === 0) {
        handleToggleModal('NO_PHONE');
      }
    }
  }, [findData])

  useEffect(() => {
    if (!redirect) return;

    const handleRedirect = async () => {
      try {
        const { userId } = await liffGetProfile();
        const order = await PlaceOrders(cart.data.code, userId);
        if (order && !order.isNotValid) {
          const urlWithOrderId = `/?seamless=${process.env.REACT_APP_NGC_STOREFRONT_URL}/checkout-retry/${order.orderNumber}`;
          window.open(urlWithOrderId, "_self");
        }
      } catch (error) {
        handleToggleModal('ERROR');
      } finally {
        setRedirect(false);
      }
    };

    handleRedirect();
  }, [redirect]);

  const handleToggleModal = (content) => {
    setModalContent(content);
    setShowModal(true);
  };

  if (!cart.data || !cart.calculated || !find.accountMst) {
    return <div> <LoadingOverlay
      active={true}
      spinner
      text="Loading"
      styles={{ wrapper: { width: '100%', height: '100%', position: 'absolute', pointerEvents: 'none' } }}
    /></div>;
  }
  if (showConsent) {
    return <PaymentConsent setAccept={() => setAccept(true)} onClick={() => setShowConsent(!showConsent)} />;
  }

  const handleAddressRender = ({ type, deliveryType }) => {
    switch (type) {
      case 'electronic':
        return (
          <Fragment>
            <div className="card-header">
              ชุดเริ่มต้นธุรกิจ
            </div>
            <div className="card-body">
              <div className="header">[ E - Starter Kit ]</div>
              <div>
                รับส่วนลด 150 บาท ในการซื้อสินค้า
              </div>
            </div>
          </Fragment>
        );
      case 'physical':
        if (deliveryType === 'atShop' && cart.data.pickupOrderGroups) {
          return (
            <Fragment>
              <div className="card-header">
                ข้อมูลการจัดส่ง
              </div>
              <div className="card-body">
                <div className="header">[ {cart.data.deliveryMode.name} ]</div>
                <div>
                  {pickStore.data.entry.deliveryPointOfService.displayName}
                </div>
                <div>
                  {pickStore.data.entry.deliveryPointOfService.address.line1.replace(/<\/?[^>]+(>|$)/g, '')}
                </div>
              </div>
            </Fragment>
          );
        }
        return (
          <Fragment>
            <div className="card-header">
              ข้อมูลการจัดส่ง
            </div>
            <div className="card-body">
              <div className="header">[ จัดส่งที่อยู่บ้าน (ที่อยู่ปัจจุบัน) ]</div>
              <div>
                ชุดคู่มือนักธุรกิจแอมเวย์แบบรูปเล่ม
              </div>
              <div>
                {cart.data.account.primaryParty.defaultAddress.formattedAddress}
              </div>
            </div>
          </Fragment>
        );
      default:
        return;
    }
  };

  const handleBankRender = ({ bankAcc }) => <div className="card-body">
    {
      bankAcc.issuingBankId && Object.prototype.hasOwnProperty.call(banksImagePath, bankAcc.issuingBankId) && <div className="left">
        <img src={banksImagePath[bankAcc.issuingBankId]} />
      </div>
    }
    <div className="right">
      <div className="bank-name">
        {bankAcc.issuingBankName}
      </div>
      <div className="bank-number">
        {bankAcc.bankAcctNum}
      </div>
    </div>
  </div>;

  const handleModalContent = () => {
    switch (modalContent) {
      case 'ERROR':
        return {
          content: 'เกิดข้อพิดพลาด กรุณาลองใหม่ในภายหลัง',
          type: 'danger',
          cancleBtn: false,
          okBtn: true,
          okText: 'ปิด',
          fnOk: () => liff.closeWindow(),
        };
      case 'NO_PHONE':
        return {
          content: ' ไม่พบข้อมูลเบอร์มือถือ กรุณาติดต่อ Amway Contact Center 027258000',
          type: 'danger',
          cancleBtn: false,
          okBtn: true,
          okText: 'โทร',
          fnOk: () => window.location = 'tel:027258000',
        };
      default:
        return;
    }
  };

  const content = handleModalContent();
  return (
    <div className="confirmpayment-container">
      {

        showModal && <Modal
          content={content.content}
          type={content.type}
          fnClose={() => setShowModal(false)}
          fnOk={content.fnOk}
          fnCancel={content.cancleBtn ? () => setShowModal(false) : null}
          closeBtn={content.closeBtn}
          okBtn={content.okBtn}
          okText={content.okText}
          cancleText="ยกเลิก" />
      }
      <div className="header">
        ตรวจสอบข้อมูลก่อนชำระเงิน
      </div>
      <div className="body mb-120">
        <Card className="price-card mt-3">
          <div className="card-body">
            {
              cartData?.entries?.filter(excludeProductEntries)?.map(data => (
                <>
                  {
                    data.basePrice.value > 0 &&
                    <div className="product" key={data.aliasCode}>
                      <div className="name">{data.product.name}</div>
                      <div className="price">{handlePriceFormatting(data.basePrice.formattedValue)}</div>
                    </div>
                  }
                </>
              ))
            }
          </div>
        </Card>
        <RenewalOrderDetailCard
          cardText={location.state.type === 'electronic' ? 'ชุด E - Starter Kit' : 'รับเป็นรูปเล่ม'}
          cardImg={location.state.type === 'electronic' ? '/images/renewalAndUpgrade/E-StarterKit.png' : '/images/renewalAndUpgrade/PhysicalKit.svg'}
          title={location.state.type === 'physical' && 'วิธีการจัดส่ง'}
          desc={location.state.type === 'physical' ?
            location.state.deliveryType === 'atShop' ?
              [`รับด้วยตัวเอง : ${pickStore && pickStore?.data?.entry?.deliveryPointOfService?.displayName}`] :
              [`จัดส่ง : ${cartData && cartData.account?.primaryParty?.defaultAddress?.formattedAddress}`] :
            []}       // for multi line description
          className="mt-3"
          style={null}
        />
        <RenewalPersonalInfoCard
          labelThai={{
            cardText: "ข้อมูลส่วนตัว",
            applicant: "ข้อมูลสมาชิก",
            sponsor: "ผู้สปอนเซอร์",
            expiryDate: "วันหมดอายุสมาชิก",
            telephoneNumber: "เบอร์โทรศัพท์",
            address: "ที่อยู่ (หลัก)",
          }}
          applicant={[find?.accountMst?.accountName, `#${find?.accountMst?.aboNum}`]}
          sponsor={[find?.sponsor?.sponsorName, `#${find?.sponsor?.sponsorABONo}`]}
          expiryDate={formattedDate}
          telephoneNumber={find?.partyList[0]?.phoneList[0].phoneLocalNum.replace(/(\d{3})(\d{3})(\d+)/, '$1-XXX-$3')}
          address={[cartData && cartData.account.primaryParty.defaultBillingAddress.formattedAddress]}
          className="mt-3"
          style={null}
        />
      </div>
      <StickyBottom buttonProps={{ type: 'submit' }} buttonText="ชำระเงินทันที" isActive={isCalculated && accept} onClick={isCalculated && accept ? () => setRedirect(true) : null}
        secondaryButtonProps={{ type: 'submit' }} secondaryButtonText="ย้อนกลับ" secondaryIsActive secondaryOnClick={() => history.push({ pathname: commonConstant.pathUpgradeChooseMag, search: '?backFromPayment=true' })}>
        <div className="home-registration-tnc-wrapper">
          <CustomCheckbox onChange={() => { setAccept(!accept) }} accept={accept} ref={checkboxRef} />
          <div className="home-registration-tnc-link">
            <div className="link" onClick={() => setShowConsent(true)}>{LABEL_ACCEPT_TNC_MEMBER_UPGRADE}</div>
          </div>
        </div>
      </StickyBottom>
    </div>
  );
};

const PaymentConsent = ({ onClick, setAccept }) => {
  const [reachedBottom, setReachedBottom] = useState(false);
  const scrollRef = useRef(null)

  useEffect(() => {
    if (scrollRef?.current) {
      handleScroll(scrollRef)
    }
  }, [scrollRef, scrollRef?.current])

  const handleScroll = (e) => {
    const { scrollHeight, scrollTop, clientHeight } = e?.target || e.current;
    if (Math.floor(scrollHeight - scrollTop - 10) <= clientHeight) {
      setReachedBottom(true);
    } else {
      setReachedBottom(false);
    }
  };

  const onAcceptClick = () => {
    setAccept();
    onClick();
  }

  return (
    <div className="payment-consent-container">
      <div ref={scrollRef} className='container-inner' onScroll={handleScroll}>
        <Card>
          <UpgradeCondition />
        </Card>
        <div className="card-footer">
          {reachedBottom &&
            <button className="away-button active" onClick={onAcceptClick}>ยอมรับ</button>
          }
          {!reachedBottom &&
            <button className="tnc-back-button" onClick={() => onClick()}>ย้อนกลับ</button>
          }
        </div>
      </div>
    </div>
  )
};